module.exports = __webpack_public_path__ + "img/instagram-logo.496ecccd.png";